module.exports = __webpack_public_path__ + "img/line-flow03.50fc2336.png";